import React, { useContext } from "react";
import { Icon } from "@fluentui/react";
import themeContext from "../../../../context/theme/ThemeContext";

const SearchResultsTabIcon = (props) => {
  const { getThemeColorForTab } = useContext(themeContext);

  return (
    <Icon
      iconName="Search"
      styles={{
        root: {
          fontSize: 14,
          color: getThemeColorForTab(props.active),
        },
      }}
    />
  );
};

export default SearchResultsTabIcon;
